import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import './styles.css';
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";

const NumberedTabsLabel: React.FC<{
  step: number,
  currentStep: number,
  text: string,
  checked: boolean,
  current: boolean
}> = ({ step, currentStep, text, checked, current }) => {

  const { textStyleAccessibility, contrastColorAccessibility, contrastBorderAccessibility } = useAccessibility();

  const [passedBy, setPassedBy] = useState<boolean>(false);

  const validateIfPassedBy = () => {
    if (current) {
      setPassedBy(true);
    }
  }

  const validateIfReturnedAfterPassingBy = () => {
    if (currentStep < step) {
      setPassedBy(false);
    }
  }

  useEffect(() => {
    validateIfPassedBy();
    validateIfReturnedAfterPassingBy();
  }, [current]);

  return (
    <div className="numbered-label-holder">
      <div className="numbered-tab-icon-holder" style={contrastBorderAccessibility}>
        <div className={`${(current || (passedBy && currentStep > step)) && 'numbered-tab-icon'}`}>
          {!checked ?
            <span style={{...contrastColorAccessibility }}>{step}</span> :
            <FontAwesomeIcon icon={faCheck} size='xs' style={{...contrastColorAccessibility }} />
          }
        </div>
      </div>
      <span style={{...textStyleAccessibility, opacity: checked ? '0.6' : '1' }}>{text}</span>
    </div>
  );
};

export default NumberedTabsLabel;
